import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {MTableEditRow} from "material-table";
import {refreshOne} from "../store/raspberryEraseStationSlice";

const RaspberryEraseStationListEditRow = (props) => {
    const { id, updateRaspberryEraseStation, activeCustomerID } = props;

    // store
    const raspberryEraseStation = useSelector((state) => state.raspberryEraseStation.list[id]);
    const dispatch = useDispatch();

    const data = {
        ...props.data,
        ...raspberryEraseStation
    }

    const modifiedProps = {
        ...props
    }

    const handleEditRow = async (mode, rowData, data) => {
        const result  = await updateRaspberryEraseStation({...rowData, ActiveCustomerID: activeCustomerID});
        if (result) {
            dispatch(refreshOne({id: rowData.EraseStationID, raspberryEraseStation: rowData}));
        }
        props.onEditingCanceled(mode, data);
    }

    delete modifiedProps["updateRaspberryEraseStation"]
    delete modifiedProps["activeCustomerID"]

    return (
        <MTableEditRow {...modifiedProps} data={data} onEditingApproved={handleEditRow} />
    )
}

export default RaspberryEraseStationListEditRow;